import { combineReducers } from "redux";

// Authentication
import authentication from "./authentication/reducer";
import settings from "./settings/reducer";
import section from "./section/reducer";
import contacts from "./contacts/reducer";
import objections from "./objections/reducer";
import developerRequests from "./developerRequests/reducer";

const rootReducer = combineReducers({
  authentication,
  section,
  settings,
  contacts,
  objections,
  developerRequests,
});

export default rootReducer;
